module.exports = __webpack_public_path__ + "img/simon-bochtler.7af6d1d6.jpg";